export default "__VITE_ASSET___zSMSVoy__"